<template>
  <div>
    <label for="currency">
      {{ $t('order.offerCurrency') }}:
    </label>

    <validation-provider
      rules="required"
      name="currency_id"
      v-slot="{ errors }">
      <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
        <v-select
          :options="currencyOptions"
          v-model="currency_id"
          :searchable="false"
          :clearable="false"
          :reduce="currency => currency.value"
          :placeholder="$t('settings.currency.chooseCurrency')"
          label="text">
          <template slot="no-options">
            {{ $t('settings.currency.noCurrenciesAvailable') }}&hellip;
          </template>
        </v-select>
      </div>

      <div class="invalid-feedback">
        {{ errors[0] }}
      </div>
    </validation-provider>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'order-select-currency',
  props: [
    'initialCurrencyID'
  ],
  computed: {
    currencyOptions () {
      return this.currencies.map(currency => ({
        value: currency.id,
        text: currency.code
      }));
    }
  },
  watch: {
    currency_id (newValue) {
      if (this.componentSetUpFinished) {
        this.$bus.$emit('order-currency-change', newValue);
      }
    },
    loadError (newValue) {
      if (newValue) {
        this.$bus.$emit('order-data-fetch-error');
      }
    },
    loadedCurrencies (newValue) {
      if (newValue) {
        this.$bus.$emit('order-data-fetch-success', 'currencies');
      }
    }
  },
  data () {
    return {
      currency_id: null,
      loadedCurrencies: false,
      currencies: [],
      loadError: false,
      componentSetUpFinished: false
    }
  },
  mounted () {
    this.currency_id = this.initialCurrencyID;

    FormUtils.loadAdditionalData(this, {
      endpoint: '/customer-panel/currencies/items',
      loadedKey: 'loadedCurrencies',
      outputKey: 'currencies',
      errorKey: 'loadError',
      successAction: () => {
        this.componentSetUpFinished = true;
      }
    });
  },
  methods: {
    setCurrencyID (newID) {
      this.currency_id = newID;
    }
  }
}
</script>
